/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Dropzone_InstructionInputs */

const en_case_dropzone_instruction = /** @type {(inputs: Case_Dropzone_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop your files here or`)
};

const pt_br2_case_dropzone_instruction = /** @type {(inputs: Case_Dropzone_InstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arraste seus arquivos aqui ou`)
};

/**
* | output |
* | --- |
* | "Drop your files here or" |
*
* @param {Case_Dropzone_InstructionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_dropzone_instruction = /** @type {((inputs?: Case_Dropzone_InstructionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Dropzone_InstructionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_dropzone_instruction(inputs)
	return pt_br2_case_dropzone_instruction(inputs)
});